export {};
declare global {
    interface Number {
        between(a: number, b: number, inclusive?: boolean): boolean;
    }
}

Number.prototype.between = function(a: number, b: number, inclusive: boolean = true) {
    const min = Math.min(a, b);
    const max = Math.max(a, b);

    return inclusive ? this >= min && this <= max : this > min && this < max;
};
